import React from 'react';
export function Footer() {
  return <footer className="bg-navy border-t border-white/10 py-10" data-id="element-124">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-125">
        <div className="text-gold font-serif text-xl tracking-wider font-medium" data-id="element-126">
          SG.
        </div>

        <div className="text-softwhite/50 text-xs uppercase tracking-widest" data-id="element-127">
          &copy; {new Date().getFullYear()} Sandra J. Gabriel. All rights
          reserved.
        </div>

        <div className="flex space-x-6" data-id="element-128">
          <a href="#about" className="text-softwhite/50 hover:text-gold text-xs uppercase tracking-widest transition-colors" data-id="element-129">
            About
          </a>
          <a href="#experience" className="text-softwhite/50 hover:text-gold text-xs uppercase tracking-widest transition-colors" data-id="element-130">
            Experience
          </a>
          <a href="#contact" className="text-softwhite/50 hover:text-gold text-xs uppercase tracking-widest transition-colors" data-id="element-131">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}